<template>
  <div>
    <div class="page-download">
      <button class="btn btn-danger btn-block btn-lg" @click="rdr_back" type="button">
        Back
      </button>
      <a href="javascript:window.print()" class="btn btn-info btn-block btn-lg" type="button"><i class="fa fa-print"></i> Cetak</a>
    </div>

    <div id="page-wrap">
      <div class="logo-header">
        <img src="@/assets/images/invoice-logo.png" />

        <div class="right-company">
          <template v-if="data.store !== undefined">
            <span> {{ data.store.str_name }} </span>
            <p>{{ data.store.str_address }}, {{ data.store.str_phone }}</p>
          </template>
        </div>
      </div>
      <div id="header"><b>INVOICE</b></div>
      <div id="customer">
        <div id="customer-title">
          <span> {{ data.usr_fullname }} </span>
          <p>{{ data.usr_address }}</p>
          <p>{{ data.usr_phone }}</p>
          <p>KM {{ numberWithCommas(data.srv_t_km) }}</p>
        </div>
        <table id="meta">
          <tr>
            <td class="meta-head">Invoice #</td>
            <td>
              <span>{{ data.srv_t_code }}</span>
            </td>
          </tr>
          <tr>
            <td class="meta-head">Date</td>
            <td>
              <span id="date">{{ data.srv_t_date }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <div class="due">
                {{ data.crs_model_name }} / {{ data.cst_crs_police_number }}
              </div>
            </td>
          </tr>
        </table>
      </div>
      <table id="items">
        <template v-if="bind_services_bulk.length > 0">
          <tr class="border_bottom">
            <th><b>Paket Service</b></th>
            <th><b>Jasa</b></th>
            <th colspan="3"><b>Barang</b></th>
            <th><b>Harga (IDR)</b></th>
          </tr>
          <tr
            class="item-row"
            v-for="(item, index) in bind_services_bulk"
            :key="index + 'bind_services_bulk'"
          >
            <td class="description">
              {{ item.srv_b_name }}
            </td>
            <td class="description">
              <span v-html="item.srv_b_description"></span>
            </td>
            <td class="description" colspan="3">
              <template v-if="item.prd_id !== undefined">
                <p v-for="(item_prd, index_prd) in item.prd_id" :key="index_prd+'prd_id'">- {{ item_prd.prd_name }}</p>
              </template>
            </td>
            <td class="price">
              {{ $root.numberWithCommas(item.srv_b_act_price) }}
            </td>
          </tr>
        </template>
        <template v-if="bind_prd.length > 0">
          <tr class="border_bottom">
            <th colspan="2"><b>BARANG</b></th>
            <!-- <th>Keterangan</th> -->
            <th><b>Harga Satuan</b></th>
            <th><b>Qty</b></th>
            <th><b>Disc</b></th>
            <th><b>Harga (IDR)</b></th>
          </tr>
          <tr
            class="item-row"
            v-for="(item, index) in bind_prd"
            :key="index + 'bind_prd'"
          >
            <td class="description" colspan="2">
              {{ item.prd_name }}
            </td>
            <!-- <td class="description"></td> -->
            <td>
              <span class="cost">
                {{ $root.numberWithCommas(item.prd_act_price) }}
              </span>
            </td>
            <td>
              <span class="qty">{{ item.prd_qty+' '+item.prd_unit }}</span>
            </td>
            <td>-</td>
            <td class="price">
              {{ $root.numberWithCommas(item.prd_total_price) }}
            </td>
          </tr>
        </template>
        <template v-if="bind_services.length > 0">
          <tr class="border_bottom">
            <th colspan="2"><b>JASA SERVICE</b></th>
            <!-- <th>Keterangan</th> -->
            <th><b>Harga Satuan</b></th>
            <th><b>Qty</b></th>
            <th><b>Disc</b></th>
            <th><b>Harga (IDR)</b></th>
          </tr>
          <tr
            class="item-row"
            v-for="(item, index) in bind_services"
            :key="index + 'bind_services'"
          >
            <td class="description" colspan="2">
              {{ item.srv_name }}
            </td>
            <td class="price">
              {{ $root.numberWithCommas(item.srv_act_price) }}
            </td>
            <td>
              <span class="qty"></span>
            </td>
            <td>{{ item.srv_discount }} %</td>
            <td class="price">
              {{ $root.numberWithCommas(item.srv_total_price) }}
            </td>
          </tr>
        </template>
        <tr>
          <td colspan="2" rowspan="3" class="blank"><i>{{ data.srv_t_note }}</i></td>
          <td colspan="3" class="total-line">Subtotal</td>
          <td class="total-value">
            <div id="subtotal">
              Rp {{ $root.numberWithCommas(data.srv_t_actual_price) }}
            </div>
          </td>
        </tr>
        <tr>
          <!-- <td colspan="2" class="blank"></td> -->
          <td colspan="3" class="total-line">Booking Fee</td>
          <td class="total-value">
            <div id="total">Rp {{ $root.numberWithCommas(data.srv_t_dp) }}</div>
          </td>
        </tr>
        <tr>
          <!-- <td colspan="2" class="blank"></td> -->
          <td colspan="3" class="total-line balance" style="font-size: 16px;"><b>Total Pembayaran</b></td>
          <td class="total-value balance" style="font-size: 16px;">
            <div class="due">
              <b>Rp {{ $root.numberWithCommas(getSisaPembayaran) }}</b>
            </div>
          </td>
        </tr>
      </table>
      <div id="terms">
        <div>
          <i>
            *Pembayaran bisa transfer ke - Rekening BCA 210-11-76-438 - Atas Nama
            Rasim Rusdianto
          </i>
        </div>
      </div>
      <table id="ttd">
        <tr>
          <td>
            <p>Customers</p>
          </td>
          <td>
            <p>Admin</p>
          </td>
        </tr>
        <tr style="height: 30px">
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>
            <p>{{ data.usr_fullname }}</p>
          </td>
          <td>
            <p><b>Admin Mentari Motor</b></p>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      module: "Transaksi Servis",
      table_module: "services_transaction",
      alias_table: "srv_t",
      data: {},
      error: {},
      uuid: this.$route.params.uuid,
      detailBulk: [],
      detailService: [],
      detailProducts: [],
    };
  },
  computed: {
    bind_services() {
      var result = [];
      if (typeof this.data.srv_t_r !== "undefined") {
        result = this.data.srv_t_r.filter(function (srv) {
          return srv.srv_t_d_type_name == "Service";
        });

        for (const key in result) {
          result[key]["spr"] = null;
          if (result[key]["spr_id"] != 0 && result[key]["spr_id"] != null) {
            result[key]["spr"] = {
              spr_id: result[key]["spr_id"],
              spr_name: result[key]["spr_name"],
            };
          }
        }
      }
      return result;
    },
    bind_services_bulk() {
      var result = [];
      if (typeof this.data.srv_t_r !== "undefined") {
        result = this.data.srv_t_r.filter(function (srv) {
          return srv.srv_t_d_type_name == "Service Bulk";
        });
      }
      return result;
    },
    bind_prd() {
      var result = [];
      if (typeof this.data.srv_t_r !== "undefined") {
        result = this.data.srv_t_r.filter(function (srv) {
          return srv.srv_t_d_type_name == "Products";
        });
      }
      return result;
    },
    filename() {
      var date = this.data.srv_t_code;
      return date;
    },
    getSisaPembayaran() {
      let result = 0;
      if (
        typeof this.data.srv_t_actual_price !== "undefined" &&
        this.data.srv_t_actual_price !== null &&
        this.data.srv_t_actual_price !== ""
      ) {
        result = this.data.srv_t_actual_price - this.data.srv_t_dp;
      }

      return result;
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.axios
        .get(this.table_module + "/detail/" + this.uuid)
        .then((response) => {
          this.data = response.data.data;
        });
    },
    numberWithCommas(arm) {
      if (arm != "" && arm != null) {
        return arm.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return 0;
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    rdr_back() {
      this.$router.push({ name: this.table_module });
    },
  },
};
</script>


<style scoped>
.border_bottom {
  border-top: 2px solid black;
  border-bottom: 2px solid black;
}

@media print {
  .page-download { display: none; }
}

* {
  margin: 0;
  padding: 0;
}
body {
  font: 14px/1.4 Georgia, serif;  
}
#page-wrap {
  width: 100%;
  margin: 0;
  font-weight : bold;
  font-size: 16px;
}

.page-download {
  width: 300px;
  margin-bottom: 20px;
  margin-left: 0px;
}

textarea {
  border: 0;
  font: 14px Georgia, Serif;
  overflow: hidden;
  resize: none;
}

table {
  border-collapse: collapse;
}
table td,
table th {
  border: 1px solid black;
  padding: 5px;
}

#header {
  width: 100%;
  margin: 0px 10px 20px 0;
  text-align: center;
  font: bold 19px Helvetica, Sans-Serif;
  text-decoration: uppercase;
  letter-spacing: 20px;
  padding: 8px 0px;
}

.cetak {
  width: 100%;
  margin: 0px 10px 20px 0;
  background: #222;
  text-align: center;
  color: white;
  font: bold 15px Helvetica, Sans-Serif;
  text-decoration: uppercase;
  letter-spacing: 20px;
  padding: 8px 0px;
}

#address {
  width: 250px;
  height: 150px;
  float: left;
}
#customer {
  overflow: hidden;
}

#logo {
  text-align: right;
  float: right;
  position: relative;
  margin-top: 25px;
  border: 1px solid #fff;
  max-width: 540px;
  max-height: 100px;
  overflow: hidden;
}
#logo:hover,
#logo.edit {
  border: 1px solid #000;
  margin-top: 0px;
  max-height: 125px;
}
#logoctr {
  display: none;
}
#logo:hover #logoctr,
#logo.edit #logoctr {
  display: block;
  text-align: right;
  line-height: 25px;
  background: #eee;
  padding: 0 5px;
}
#logohelp {
  text-align: left;
  display: none;
  font-style: italic;
  padding: 10px 5px;
}
#logohelp input {
  margin-bottom: 5px;
}
.edit #logohelp {
  display: block;
}
.edit #save-logo,
.edit #cancel-logo {
  display: inline;
}
.edit #image,
#save-logo,
#cancel-logo,
.edit #change-logo,
.edit #delete-logo {
  display: none;
}
#customer-title {
  float: left;
}
#customer-title span {
  font-size: 16px;
  font-weight: bold;
}
#customer-title p {
  font-size: 14px;
}

#meta {
  margin-top: 1px;
  width: 300px;
  float: right;
}
#meta td {
  text-align: right;
}
#meta td.meta-head {
  text-align: left;
  background: #eee;
}
#meta td textarea {
  width: 100%;
  height: 20px;
  text-align: right;
}

#items {
  clear: both;
  width: 100%;
  margin: 30px 0 0 0;
  border: 1px solid black;
}
#items th {
  background: #eee;
}
#items textarea {
  width: 80px;
  height: 50px;
}
#items tr.item-row td {
  vertical-align: top;
}
#items td.description {
  width: 450px;
}
#items td.item-name {
  width: 175px;
}
#items td.description textarea,
#items td.item-name textarea {
  width: 100%;
}
#items td.total-line {
  border-right: 0;
  text-align: right;
}
#items td.total-value {
  border-left: 0;
  padding: 10px;
}
#items td.total-value textarea {
  height: 20px;
  background: none;
}
#items td.balance {
  background: #eee;
  font: bold 13px Helvetica, Sans-Serif;
}
#items td.blank {
  border: 0;
}

#terms {
  /* text-align: center; */
  margin: 0px 0 0 0;
}
#terms h5 {
  text-transform: uppercase;
  font: 13px Helvetica, Sans-Serif;
  letter-spacing: 10px;
  border-bottom: 1px solid black;
  padding: 0 0 8px 0;
  margin: 0 0 8px 0;
}
#terms textarea {
  width: 100%;
  text-align: center;
}

textarea:hover,
textarea:focus,
#items td.total-value textarea:hover,
#items td.total-value textarea:focus,
.delete:hover {
  background-color: #eeff88;
}

.delete-wpr {
  position: relative;
}
.delete {
  display: block;
  color: #000;
  text-decoration: none;
  position: absolute;
  background: #eeeeee;
  font-weight: bold;
  padding: 0px 3px;
  border: 1px solid;
  top: -6px;
  left: -22px;
  font-family: Verdana;
  font-size: 12px;
}

#ttd {
  clear: both;
  width: 100%;
  margin: 60px 0 0 0;
  border: 0px solid black;
  text-align: center;
}

#ttd td,
#ttd th {
  border: 0px solid black !important;
  padding: 5px;
}
.logo-header {
  display: block;
  margin-bottom: 0px;
  height: 70px;
}

.logo-header img {
  height: 100px;
  margin-bottom: 0px;
  /* margin-left: -20px; */
}

.right-company {
  float: right;
  margin-top: 10px;
  text-align: right;
}

.right-company span {
  font-weight: bold;
  font-size: 19px;
}

#items td.price {
  width: 175px;
}
</style>
